import { ProductPage, MainPage, SeoFooter } from '@/components'
import { PageHead } from '@/components'

const GeneralProduct = ({ data, product, articles }) => {
    if (product) {
        return (
            <>
                <PageHead meta={product.seo_meta}/>
                <ProductPage product={product} />
                {product.seo_meta.addtional_description && <SeoFooter text={product.seo_meta.addtional_description}/>}
            </>
        )
    } else if (data) {
        return (
            <>
                <PageHead meta={data.seo_meta}/>
                <MainPage data={data} articles={articles} />
                {data.seo_meta.addtional_description && <SeoFooter text={data.seo_meta.addtional_description} />}
            </>
        )
    }
}

GeneralProduct.getInitialProps = async ({ api, query, res, city, cities }) => {
    let data = {}
    let articles = []

    if (cities.find((item) => item.slug === query.slug)) {
        if (city.is_default) {
            //если город дэфолтный и он совпадает с выбранным
            if (res) {
                res.writeHead(302, {
                    Location: '/',
                })
                res.end()
            } else {
                Router.push('/')
            }
            return
        } else {
            // если нужно показать главную страницу другого (не дэфолтного) города
            data = await api.pageWithSlug('index')({ city: query.slug })
            articles = await api.articles.main()
        }
    } else {
        // или просто показываем продуктовую страницу, если слаг не совпадает ни с каким городом
        data = await api.page({ slug: query.slug })
    }

    return cities.find((item) => item.slug === query.slug)
        ? { data: data.data, articles: articles.data, footer: 'large' }
        : { product: data.data }
}

export default GeneralProduct
